import { createContext, useEffect, useState } from 'react';
import { authAPI } from '../services/api';
import { getStoredAuthToken } from '../utils/authStorage';

export const AuthContext = createContext();

const readStoredUser = () => {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (error) {
    console.error('Invalid user data in localStorage, clearing session:', error);
    localStorage.removeItem('user');
    return null;
  }
};

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(readStoredUser());

  const login = (userData) => {
    const profile = userData?.user ? { ...userData.user } : null;
    const organizations = profile?.organizations || [];
    if (profile && !profile.activeOrganizationId) {
      profile.activeOrganizationId = organizations[0]?.organizationId || null;
    }
    const next = profile ? { ...userData, user: profile } : userData;
    localStorage.setItem('user', JSON.stringify(next));
    setUser(next);
  };

  const logout = () => {
    localStorage.removeItem('user');
    setUser(null);
  };

  const setActiveOrganization = (organizationId) => {
    setUser((current) => {
      if (!current) return current;
      const profile = current.user ? { ...current.user, activeOrganizationId: organizationId } : { ...current, activeOrganizationId: organizationId };
      const next = current.user ? { ...current, user: profile } : profile;
      localStorage.setItem('user', JSON.stringify(next));
      return next;
    });
    window.location.reload();
  };

  useEffect(() => {
    if (!getStoredAuthToken()) return undefined;
    let cancelled = false;
    authAPI
      .session()
      .then((res) => {
        if (cancelled) return;
        const organizations = res.data?.organizations || [];
        setUser((current) => {
          if (!current) return current;
          const profile = current.user ? { ...current.user } : { ...current };
          profile.organizations = organizations;
          const stillValid = organizations.some((org) => org.organizationId === profile.activeOrganizationId);
          if (!stillValid) profile.activeOrganizationId = organizations[0]?.organizationId || null;
          const next = current.user ? { ...current, user: profile } : profile;
          localStorage.setItem('user', JSON.stringify(next));
          return next;
        });
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, setActiveOrganization }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;